const agentSession = (attribute) => {
  if (localStorage.getItem('agent'))
    return JSON.parse(localStorage.getItem('agent'))[attribute];
  return null;
};

export const simulatedAgentSession = (attribute) => {
  if (localStorage.getItem('simulatedAgent'))
    return JSON.parse(localStorage.getItem('simulatedAgent'))[attribute];
  return null;
};

export default agentSession;
